import { ConnectOptionType, type ConnectOptionKind } from '@/common/bot/enum';
import { capitalizeFirstLetters } from '@/common/utils';
import { i18n } from '@/plugins/i18n';

export const getConnectOptionChannelLabel = (connectOption: ConnectOptionKind): string => {
  switch (connectOption) {
    case ConnectOptionType.LIVE_CHAT:
      return i18n.t('page.connect.live_chat') as string;
    case ConnectOptionType.VOICE_AI:
      return i18n.t('page.connect.voice_chat') as string;
    case ConnectOptionType.VOICE_CALL:
      return i18n.t('page.connect.voice_call') as string;
    case ConnectOptionType.OPEN_REQUEST:
      return i18n.t('page.connect.open_request.text') as string;
    case ConnectOptionType.FOLLOW_UP:
      return i18n.t('page.connect.follow_up.text') as string;
    case ConnectOptionType.CANCEL:
      return i18n.t('page.connect.overloaded.cancel') as string;
    default:
      return capitalizeFirstLetters(ConnectOptionType[connectOption], '_');
  }
};
